import { Component, EventEmitter, OnDestroy, OnInit, Output, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from '../../services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'pos-app-lib-customer-order-salesperson-selector',
  templateUrl: './customer-order-salesperson.component.html',
  styleUrls: ['./customer-order-salesperson.component.scss'],
})
export class CustomerOrderSalesPersonSelector implements OnInit, OnDestroy {
  @Input() currentSalesPerson: string;
  @Input() orderNumber: number;
  @Input() orderType: string;
  @Input() JDEOrderType: string;
  @Input() JDECompany: string;

  @Input() salesPeopleList: any;
  @Output() reloadData = new EventEmitter();
  @Output() closeActiveModal = new EventEmitter();
  selectedSalesPerson: string;
  formValid: boolean;
  salesPersonSearchForm: FormGroup;
  unSubscribe$ = new Subject<void>();
  constructor(private apiService: ApiService, private toastr: ToastrService) {}

  ngOnInit() {}

  handleSelectedUser(user) {
    this.selectedSalesPerson = user?.userEmail;
    if (this.selectedSalesPerson && (user?.name !== this.currentSalesPerson || user?.name !== this.currentSalesPerson)) {
      this.formValid = true;
    } else {
      this.formValid = false;
    }
  }

  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  handleCloseModel() {
    this.closeActiveModal.emit();
  }
  updateSalsePerson() {
    this.apiService
      .updateOwnerOfSavedOrder({
        orderNumber: this.orderNumber,
        JDEOrderType: this.JDEOrderType,
        JDECompany: this.JDECompany,
        newOwner: this.selectedSalesPerson,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((res) => {
        if ((res.errorFlag = '0')) {
          this.reloadData.emit();
          this.toastr.success('Salesperson updated successfully');
        } else {
          this.toastr.error(res?.errorMessage);
        }
      });
  }
}
